import { Box } from '@ublend-npm/aulaui-core';
import React from 'react';
import { Virtuoso } from 'react-virtuoso';

type InfiniteScrollerProps<T> = {
  items?: T[];
  loadMore: () => void;
  hasMore?: boolean;
  loading?: boolean;
  renderItem: (item: T, index: number) => React.ReactNode;
  height: number | string;
  orientation?: 'vertical' | 'horizontal';
};

const InfiniteScroller = <T,>({
  items = [],
  loadMore,
  hasMore = true,
  loading = false,
  renderItem,
  height,
  orientation = 'vertical',
}: InfiniteScrollerProps<T>): JSX.Element => {
  return (
    <Box
      role="list"
      aria-busy={loading}
      aria-label="Recent updates"
      sx={(theme) => ({
        height,
        width: '100%',
        scrollbarWidth: 'thin',
        scrollbarColor: `${theme.palette.primary.main} #D9D9D9`,
        '& ::-webkit-scrollbar, &::-webkit-scrollbar': {
          width: '6px',
          height: '6px',
        },
        '& ::-webkit-scrollbar-track, &::-webkit-scrollbar-track': {
          backgroundColor: '#D9D9D9',
          borderRadius: '3px',
        },
        '& ::-webkit-scrollbar-thumb, &::-webkit-scrollbar-thumb': {
          backgroundColor: theme.palette.primary.main,
          borderRadius: '3px',
        },
      })}
    >
      <Virtuoso
        style={{ height: '100%', width: '100%' }}
        horizontalDirection={orientation === 'horizontal'}
        totalCount={items.length}
        endReached={() => {
          if (!loading && hasMore) {
            loadMore();
          }
        }}
        overscan={500}
        itemContent={(index) => renderItem(items[index], index)}
      />
    </Box>
  );
};

export default InfiniteScroller;
